import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    durationLabel: {
        id: '_.loan_builder.display_table.duration_label',
        defaultMessage: 'Term length'
    },
    duration: {
        id: '_.loan_builder.display_table.duration',
        defaultMessage: `{duration} months`
    },
    monthlyRepaymentsLabel: {
        id: '_.loan_builder.display_table.monthly_repayments_label',
        defaultMessage: 'Minimum monthly repayment'
    },
    interestRateLabel: {
        id: '_.loan_builder.display_table.interest_rate_label',
        defaultMessage: 'Interest rate per 30 days'
    },
    upfrontFeeLabel: {
        id: '_.loan_builder.display_table.upfront_fee_label',
        defaultMessage: 'Upfront fee'
    },
    totalRepaymentLabel: {
        id: '_.loan_builder.display_table.total_repayment_label',
        defaultMessage: 'Total repayment {tooltip}'
    },
    totalRepaymentTooltip: {
        id: '_.loan_builder.display_table.total_repayment_tooltip',
        defaultMessage:
            'Bring this down by repaying more than the monthly minimum'
    },
    selectLabel: {
        id: '_.loan_builder.display_table.select_label',
        defaultMessage: 'Select an option {tooltip}'
    },
    selectLabelTooltip: {
        id: '_.loan_builder.display_table.select_label.tooltip',
        defaultMessage:
            'Once you’ve drawn down, you won’t be able to switch to a different option until you’ve paid off in full'
    },
    repaymentScheduleLabel: {
        id: '_.loan_builder.display_table_repayment_schedule_label',
        defaultMessage: 'Repayment schedule'
    },
    tableTitleMobile: {
        id: '_.loan_builder.display_table_title_mobile',
        defaultMessage: 'View your {options} below'
    },
    tableTitleOptions: {
        id: '_.loan_builder.display_table_title_options',
        defaultMessage: '2 options'
    },
    selectLabelSubText: {
        id: '_.loan_builder.display_table_select_option_subtext',
        defaultMessage:
            'Once you’ve selected an option click the Continue button below'
    }
});
